module.exports = __webpack_public_path__ + "img/ENVIA.677b306d.png";